<template>
  <div v-html="cleanMessage" v-linkified:options="linkifiedOptions"></div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'Message',
  components: {},
  props: {
    message: {
      required: true
    }
  },
  data() {
    return {
        linkifiedOptions: {
            truncate: 20,
            attributes: null,
            className: null,
            defaultProtocol: 'https',
            events: null,
            format: {
                url: (value) => value.length > 20 ? value.slice(0, 20) + '…' : value,
            },
            formatHref: (href, type) => href,
            ignoreTags: [],
            nl2br: true,
            rel: null,
            tagName: 'a',
            target: '_blank',
            validate: true
        }
    }
    },
  computed: {
    cleanMessage() {
      return this.$sanitize(this.message);
    }
  },
}

</script>

<style lang="scss">
  .message {
		padding: 1rem;
		background: #f1f1f1;
		border-radius: 1rem;
		color: #000;

    &.self {
			background: #1d476d;
			color: #ffffff;
			a {
        color: #5ee4d9;
				font-weight: 400;
        text-decoration: underline;

        &:hover {
          color: #d6d4d4;
        }

				&.mention {
					color: #ffdd77;
					font-weight: 400;
					background: #a07800;
					padding: 0px 4px;
				}

				&.application {
					color: #5ee4d9;
					font-weight: 400;
				}
      }

    }
    &.other {
      a {
        font-weight: bold;
        text-decoration: underline;
      }
    }
  }
</style>
